// https://developer.mozilla.org/ja/docs/Web/API/SubtleCrypto/digest#ダイジェスト値を16進文字列に変換する
async function digestMessage(message: string, salt = '') {
  const msgUint8 = new TextEncoder().encode(message + salt);                           // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8);              // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;
}

const lineTypeWhiteList = [
  "YK",
  "RE",
  "HO",
  "KO",
  "SN",
  "JD",
  "MF",
  "SH",
  "CZ",
  "IY",
  "TO",
  "CO",
  "TK",
  "KI",
  "ST",
  "GO",
]

/*5: 氏名   + 6: 男女区分/7: 生年月日を使って患者が一意になるようにする
  15〜34: 保険医師名
  35: 麻薬免許番号
  42: カタカナ(氏名)   + 6: 男女区分/7: 生年月日を使って患者が一意になるようにする */
async function hashedRE(line: string, salt: string): Promise<string> {
  const tuple  = line.split(',');
  if (![41,42].includes(tuple.length)) {  // 41 は古い形式に対応するため
    throw `RE カラム数が不正です: ${tuple.length}`
  }
  const concatedPatient = `${tuple[4]}${tuple[5]}${tuple[6]}`;
  tuple[4]  = await digestMessage(concatedPatient, salt)
  for (let i = 14; i <= 33; i++) {
    tuple[i]  = await digestMessage(tuple[i], salt)
  }
  tuple[34] = await digestMessage(tuple[34], salt)
  if (tuple[41] !== undefined) {
    const concatedKana = `${tuple[41]}${tuple[5]}${tuple[6]}`;
    tuple[41] = await digestMessage(concatedKana, salt);
  }
  tuple[6] = tuple[6].replace(/..$/, '01'); // 7: 生年月日は毎月１日に丸める
  return tuple.join(',');
}

async function hashedHO(line: string, salt: string): Promise<string> {
  const tuple  = line.split(',');
  tuple[1] = await digestMessage(tuple[1], salt)
  tuple[2] = await digestMessage(tuple[2], salt)
  tuple[3] = await digestMessage(tuple[3], salt)
  return tuple.join(',');
}

async function hashedKO(line: string, salt: string): Promise<string> {
  const tuple  = line.split(',');
  tuple[2] = await digestMessage(tuple[2], salt)
  return tuple.join(',');
}

/*4: 保険者番号等（資格確認）
  5: 被保険者証（手帳）等の記号（資格確認）
  6: 被保険者証（手帳）等の番号（資格確認）
  8: 受給者番号 */
async function hashedSN(line: string, salt: string): Promise<string> {
  const tuple  = line.split(',');
  tuple[3] = await digestMessage(tuple[3], salt)
  tuple[4] = await digestMessage(tuple[4], salt)
  tuple[5] = await digestMessage(tuple[5], salt)
  tuple[7] = await digestMessage(tuple[7], salt)
  return tuple.join(',');
}

async function hash(line: string, salt: string): Promise<string> {
  const lineType = line.substring(0, 2);
  if (!lineTypeWhiteList.includes(lineType)) {
    throw `CYO形式ではありません: ${lineType}` //TODO
  }

  switch(lineType) {
    case 'RE':
      return hashedRE(line, salt);
    case 'HO':
      return hashedHO(line, salt);
    case 'KO':
      return hashedKO(line, salt);
    case 'SN':
      return hashedSN(line, salt);
    default:
      return line;
  }
}

export { hash, digestMessage };
